import { createContext, useContext } from 'react';

import { type LiveStatus } from './live-updates';

/**
 * The shell opens ONE live stream (`useLiveUpdates()` in AppShell); screens that show its state (the dashboard's
 * « En direct » pill) read it from here instead of opening a second stream.
 */
export const LiveStatusContext = createContext<LiveStatus>('offline');

export function useLiveStatus(): LiveStatus {
  return useContext(LiveStatusContext);
}
